export function isObject(value: unknown): boolean {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

export function isString(value: unknown): boolean {
  return typeof value === 'string' || value instanceof String;
}

export function wait(time = 0): Promise<void> {
  return new Promise((resolve) => { setTimeout(resolve, time); });
}

// Generate id from random numbers and letters
export function generateIdShort(): string {
  return Math.random().toString(36).slice(2);
}

export function generateId(): string {
  return generateIdShort() + generateIdShort();
}

export function isNil(value: unknown): boolean {
  return value === undefined || value === null;
}
